import { Box } from '@spark-web/box';
import { Container } from '@spark-web/container';
import { Heading } from '@spark-web/heading';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import { FC } from 'react';

import { MarketplacePartner } from '~/types/marketplace';

import { CheckIcon } from './common/icon';

const marketplaceInformation = ['Free no-obligation quotes', 'Local accredited vendors'];

type MarketplaceInformationProps = {
  partner?: MarketplacePartner;
};

export const MarketplaceInformation: FC<MarketplaceInformationProps> = ({ partner }) => {
  return (
    <Container size="large">
      <Stack gap="xlarge" paddingY="xxxlarge" paddingX="large">
        <Heading level="1">Get quotes from Brighte vendors</Heading>

        <Box display="flex" flexDirection={{ mobile: 'column', desktop: 'row' }} gap="medium">
          {marketplaceInformation.map((info, i) => (
            <Box key={i} display="flex" flexDirection="row" alignItems="center" gap="small">
              <CheckIcon partner={partner} brighteSize="xxsmall" />
              <Text size="xsmall">{info}</Text>
            </Box>
          ))}
        </Box>
      </Stack>
    </Container>
  );
};
